import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const key = 'analytics';

const rootSelector = (state) => {
  if (state && state[key]) {
    return state[key];
  }
  return initialState;
};

export const analyticSelector = createSelector(rootSelector, (state) => state);
